module.exports = __webpack_public_path__ + "img/1.78e2415a.png";